import type { ApiResponse } from '@/types';

function getApiBaseUrl(): string {
  const envUrl = import.meta.env.VITE_API_URL;
  if (!envUrl) return '/api';
  if (envUrl.endsWith('/api')) return envUrl;
  return envUrl.replace(/\/$/, '') + '/api';
}

const API_BASE_URL = getApiBaseUrl();

async function request<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> {
  const token = localStorage.getItem('auth_token');
  const headers: HeadersInit = { 'Content-Type': 'application/json', ...options.headers };
  if (token) (headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
  if (window.Telegram?.WebApp?.initData) {
    (headers as Record<string, string>)['X-Telegram-Init-Data'] = window.Telegram.WebApp.initData;
  }
  const response = await fetch(`${API_BASE_URL}${endpoint}`, { ...options, headers });
  const data: ApiResponse<T> = await response.json();
  if (!response.ok || !data.success) throw new Error(data.error || 'Unknown error');
  return data.data as T;
}

// ============================================
// TYPES
// ============================================

export interface BatteryCInput {
  stateItems: Array<{ question: number; value: number }>;
  fcItems: Array<{ question: number; choice: 'A' | 'B' }>;
  anchors: Array<{ question: number; text: string }>;
  completionTimeSeconds: number;
}

export interface BatteryCResult {
  stateIndex: number;
  styleProfile: Record<string, string>;
  quality: {
    valid: boolean;
    lowConfidence: boolean;
    uniformAnswers: boolean;
    reason: string | null;
  };
  tieBreakApplied: boolean;
  updatedArchetypes: {
    primary: string;
    secondary: string;
    shadow: string;
  } | null;
}

// ============================================
// API
// ============================================

export async function submitBatteryC(input: BatteryCInput): Promise<BatteryCResult> {
  return request<BatteryCResult>('/battery-c/submit', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function getBatteryCResult(): Promise<BatteryCResult> {
  return request<BatteryCResult>('/battery-c/result');
}
